// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"22":"5bd83a66","106":"bcdc8912","549":"18c66413","710":"2bce64d9","776":"e500cfb5","923":"cfb56ca2"}[chunkId] + ".js";
};